import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class RocketBadge extends WritingBadge {
  public readonly id = BadgeId.rocket;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.wordsCount >= 50000;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/rocket.ts